/* HK storefront behaviours: announcement close, footer accordion, card swatches. */
(function () {
  if (window.__hkThemeInit) return;
  window.__hkThemeInit = true;

  var STORE = 'hk-announcement-closed';

  function safeGet(k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } }
  function safeSet(k, v) { try { sessionStorage.setItem(k, v); } catch (e) {} }

  /* ---- Announcement bar close ---- */
  function initAnnouncements() {
    document.querySelectorAll('[data-announcement-close]').forEach(function (btn) {
      var bar = btn.closest('.utility-bar');
      if (!bar) return;
      if (safeGet(STORE + ':' + btn.dataset.announcementClose)) bar.hidden = true;
    });
  }
  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-announcement-close]');
    if (!btn) return;
    var bar = btn.closest('.utility-bar');
    if (bar) bar.hidden = true;
    safeSet(STORE + ':' + btn.dataset.announcementClose, '1');
  });

  /* ---- Footer accordion (phones) ---- */
  var mq = window.matchMedia('(max-width: 749px)');
  function initFooterAccordion() {
    document.querySelectorAll('.footer-block--menu .footer-block__heading').forEach(function (h) {
      if (mq.matches) {
        if (h.classList.contains('is-collapsible')) return;
        h.classList.add('is-collapsible');
        h.setAttribute('role', 'button');
        h.setAttribute('tabindex', '0');
        h.setAttribute('aria-expanded', 'false');
      } else if (h.classList.contains('is-collapsible')) {
        h.classList.remove('is-collapsible');
        h.removeAttribute('role');
        h.removeAttribute('tabindex');
        h.removeAttribute('aria-expanded');
      }
    });
  }
  function toggleHeading(h) {
    h.setAttribute('aria-expanded', h.getAttribute('aria-expanded') === 'true' ? 'false' : 'true');
  }
  document.addEventListener('click', function (event) {
    var h = event.target.closest('.footer-block__heading.is-collapsible');
    if (h) toggleHeading(h);
  });
  document.addEventListener('keydown', function (event) {
    var h = event.target.closest && event.target.closest('.footer-block__heading.is-collapsible');
    if (h && (event.key === 'Enter' || event.key === ' ')) {
      event.preventDefault();
      toggleHeading(h);
    }
  });
  if (mq.addEventListener) mq.addEventListener('change', initFooterAccordion);

  /* ---- Product card swatches: swap card image, reflect selection ---- */
  function swapCardImage(swatch) {
    var card = swatch.closest('.card-wrapper');
    if (!card || !swatch.dataset.imageSrc) return;
    var img = card.querySelector('.card__media img');
    if (!img) return;
    if (!img.dataset.hkOrigSrc) {
      img.dataset.hkOrigSrc = img.getAttribute('src');
      img.dataset.hkOrigSrcset = img.getAttribute('srcset') || '';
    }
    img.setAttribute('src', swatch.dataset.imageSrc);
    if (swatch.dataset.imageSrcset) img.setAttribute('srcset', swatch.dataset.imageSrcset);
  }
  function restoreCardImage(card) {
    var img = card.querySelector('.card__media img');
    if (!img || !img.dataset.hkOrigSrc) return;
    var selected = card.querySelector('.card-swatches__item[aria-current="true"]');
    if (selected) return swapCardImage(selected);
    img.setAttribute('src', img.dataset.hkOrigSrc);
    if (img.dataset.hkOrigSrcset) img.setAttribute('srcset', img.dataset.hkOrigSrcset);
  }
  document.addEventListener('click', function (event) {
    var swatch = event.target.closest('.card-swatches__item');
    if (!swatch) return;
    event.preventDefault(); // stay on the listing; the card itself links to the product
    var group = swatch.parentElement;
    group.querySelectorAll('.card-swatches__item').forEach(function (s) { s.removeAttribute('aria-current'); });
    swatch.setAttribute('aria-current', 'true');
    swapCardImage(swatch);
    var card = swatch.closest('.card-wrapper');
    if (card) {
      // keep the card links pointing at the chosen colour
      card.querySelectorAll('a.full-unstyled-link').forEach(function (a) {
        a.setAttribute('href', swatch.getAttribute('href'));
      });
    }
  });
  document.addEventListener('mouseover', function (event) {
    if (!window.matchMedia('(hover: hover)').matches) return;
    var swatch = event.target.closest && event.target.closest('.card-swatches__item');
    if (swatch) swapCardImage(swatch);
  });
  document.addEventListener('mouseout', function (event) {
    if (!window.matchMedia('(hover: hover)').matches) return;
    var swatch = event.target.closest && event.target.closest('.card-swatches__item');
    if (!swatch) return;
    var card = swatch.closest('.card-wrapper');
    if (card && !(event.relatedTarget && swatch.parentElement.contains(event.relatedTarget))) restoreCardImage(card);
  });

  function init() { initAnnouncements(); initFooterAccordion(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
